import { supabase } from '@/lib/supabase';
import type { Database, NoteRow } from '@/types/database';

type NoteInsert = Database['public']['Tables']['notes']['Insert'];
type NoteUpdate = Database['public']['Tables']['notes']['Update'];

export async function listNotes(projectId: string): Promise<NoteRow[]> {
  const { data, error } = await supabase
    .from('notes')
    .select('*')
    .eq('project_id', projectId)
    .order('pinned', { ascending: false })
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data ?? [];
}

export async function createNote(input: NoteInsert): Promise<NoteRow> {
  const { data, error } = await supabase.from('notes').insert(input).select().single();
  if (error) throw error;
  return data;
}

export async function updateNote(id: string, patch: NoteUpdate): Promise<NoteRow> {
  const { data, error } = await supabase.from('notes').update(patch).eq('id', id).select().single();
  if (error) throw error;
  return data;
}

export async function deleteNote(id: string): Promise<void> {
  const { error } = await supabase.from('notes').delete().eq('id', id);
  if (error) throw error;
}
